import { styled, Box } from "@mui/material";

export const WrapperUIRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "100vh",
  width: "100%",
}));

export const MenuContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    !["menuOpen", "animReady", "isMobile"].includes(prop),
})(({ theme, menuOpen, animReady, isMobile }) => ({
  // Absolute inside WrapperUIRoot, which fills the viewport
  position: "fixed",
  margin: "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  zIndex: 999,
  pointerEvents: menuOpen ? "auto" : "none",
  transition: animReady ? "transform 0.4s ease-in-out" : "none",
}));
